(function () {
  var WORKER_URL = "https://stormsure-sales.marketing-f1f.workers.dev";

  function injectBadges(badges) {
    var cards = document.querySelectorAll("[data-bp-group]");
    cards.forEach(function (card) {
      var groupId = card.dataset.bpGroup;
      var label = badges[groupId];
      if (!label) return;

      // Avoid duplicating if script runs twice
      if (card.querySelector(".sales-badge")) return;

      var badge = document.createElement("p");
      badge.className = "sales-badge";
      badge.textContent = label + " bought in past month";

      var nameEl = card.querySelector(".product-card__name");
      if (!nameEl) return;
      nameEl.parentNode.insertBefore(badge, nameEl);
    });
  }

  function loadBadges() {
    fetch(WORKER_URL, { mode: "cors" })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(injectBadges)
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadBadges);
  } else {
    loadBadges();
  }
})();
